import React from 'react';
import '../../styles/Modals.css';

const ConfirmActionModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel', 
  variant = 'danger',
  confirmColor,
  loading = false
}) => {
  if (!isOpen) return null;

  const getConfirmButtonStyle = () => {
    if (confirmColor) {
      return {
        background: confirmColor,
        color: 'white',
      };
    }
    if (variant === 'danger') {
      return {
        background: 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)',
        color: 'white',
      };
    }
    return {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
    };
  };

  const handleConfirm = async () => {
    if (!loading) {
      const result = onConfirm();
      // If onConfirm returns a promise, wait for it but don't auto-close
      // The parent component should handle closing after async operations
      if (result && typeof result.then === 'function') {
        try {
          await result;
        } catch (error) {
          // Error is handled by parent component
        }
      }
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#2d3748' }}>{title}</h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <p
          style={{
            margin: '0 0 24px 0',
            fontSize: '14px',
            color: '#4a5568',
            lineHeight: '1.5',
            whiteSpace: 'pre-line',
          }}
        >
          {message}
        </p>

        <div className="modal-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '10px 20px',
              background: '#e2e8f0',
              color: '#4a5568',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '13px'
            }}
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '10px 20px',
              ...getConfirmButtonStyle(),
              border: 'none',
              borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: 600,
              fontSize: '13px',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;

